import React, { useState, useEffect } from 'react';
import { X, MessageCircle, Phone } from 'lucide-react';

const LeadPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show popup after 20 seconds, only once per session
    const shown = sessionStorage.getItem('popupShown');
    if (!shown) {
      const timer = setTimeout(() => {
        setIsVisible(true);
        sessionStorage.setItem('popupShown', 'true');
      }, 20000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleWhatsApp = () => {
    const message = 'Hi! I am looking for a puppy. Can you help me with available breeds and pricing?';
    window.open(`https://wa.me/917217648679?text=${encodeURIComponent(message)}`, '_blank');
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed inset-0 flex items-end sm:items-center justify-center z-[9999] p-4"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
      onClick={handleClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-sm relative animate-slide-up"
        style={{
          backgroundColor: 'white',
          borderRadius: '1.25rem',
          overflow: 'hidden',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
        }}
        data-testid="lead-popup"
      >
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 p-1.5 rounded-full transition-colors hover:bg-gray-100"
          style={{ color: '#9CA3AF' }}
          aria-label="Close popup"
        >
          <X size={20} />
        </button>

        {/* Content */}
        <div className="p-6 pt-8 text-center">
          {/* Logo */}
          <div className="mb-4 flex justify-center">
            <img
              src="/petsmart-logo.png"
              alt="Petsmart Puppies"
              className="w-16 h-16 rounded-full object-cover shadow-md"
            />
          </div>

          {/* Title */}
          <h2 className="text-xl font-bold mb-2" style={{ color: '#1F2937' }}>
            Looking for a Healthy Puppy?
          </h2>
          
          {/* Description */}
          <p className="text-sm mb-5 leading-relaxed" style={{ color: '#6B7280' }}>
            Chat with us on WhatsApp for puppy availability, pricing, breed guidance, and store visit details.
          </p>

          {/* Primary CTA */}
          <button
            onClick={handleWhatsApp}
            data-testid="popup-whatsapp-button"
            className="w-full py-3 px-4 rounded-xl font-semibold text-white flex items-center justify-center gap-2 transition-all active:scale-98"
            style={{
              backgroundColor: '#25D366',
              boxShadow: '0 4px 14px rgba(37, 211, 102, 0.3)'
            }}
          >
            <MessageCircle size={20} />
            Chat on WhatsApp
          </button>

          {/* Secondary CTA */}
          <button
            onClick={handleClose}
            className="mt-3 py-2 px-4 text-sm font-medium transition-colors"
            style={{ color: '#9CA3AF' }}
          >
            Maybe Later
          </button>
        </div>

        {/* Bottom accent */}
        <div 
          className="h-1"
          style={{ background: 'linear-gradient(90deg, #0EA5E9, #25D366)' }}
        />
      </div>

      <style>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
        .active\\:scale-98:active {
          transform: scale(0.98);
        }
      `}</style>
    </div>
  );
};

export default LeadPopup;
